export enum docType{
    /* Условия использования регистрация */
    PrivacyPolicy = 1,
    TermsOfUse = 2,
    UserAgreement = 3,
    Litepaper = 4
}